/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************************!*\
  !*** ./src/assets/js/pdp-sticky-atc.js ***!
  \*****************************************/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
(() => {
  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }
  function normalizeSummaryValue(value) {
    return cleanText(value).toLowerCase().replace(/-/g, ' ');
  }
  function formatPackLabel(value, quantity) {
    const label = cleanText(value).replace(/-/g, ' ');
    if (!label) return quantity > 1 ? `${quantity} Pack` : 'Single';
    return label.replace(/\bpack\b/i, 'Pack');
  }
  function isVisibleElement(element) {
    if (!element) return false;
    if (element.hidden) return false;
    if (element.style && element.style.display === 'none') return false;
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }
  function formatMoney(cents, fallback) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return fallback || `$${(cents / 100).toFixed(2)}`;
  }
  function initStickyAtc(bar) {
    if (!bar || bar.dataset.stickyAtcInitialized === 'true') return;
    const mainProduct = bar.closest('product-info');
    if (!mainProduct) return;
    bar.dataset.stickyAtcInitialized = 'true';
    const sectionId = mainProduct.dataset.section;
    const variantInput = bar.querySelector('[data-sticky-variant-id]');
    const sellingPlanInput = bar.querySelector('[data-sticky-selling-plan-id]');
    const quantityInput = bar.querySelector('[data-sticky-quantity]');
    const variantsScript = bar.querySelector('[data-sticky-variants]');
    const buttonPrice = bar.querySelector('[data-sticky-button-price]');
    const selectedOptions = bar.querySelector('[data-sticky-selected-options]');
    const selectedFrequency = bar.querySelector('[data-sticky-selected-frequency]');
    const selectedFrequencyText = bar.querySelector('[data-sticky-selected-frequency-text]');
    const addButton = bar.querySelector('[data-sticky-add-button]');
    const form = bar.querySelector('form');
    const stickyProductForm = bar.querySelector('product-form');
    const mainForm = sectionId ? document.getElementById(`product-form-${sectionId}`) : null;
    const packProductForm = mainProduct.querySelector('pack-product-form');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    let ticking = false;
    let variants = [];
    let currentAvailable = !addButton?.disabled;
    let currentVariant = null;
    let packSubmitError = false;
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (error) {
      variants = [];
    }
    function getFooterElement() {
      return document.querySelector('#shopify-section-footer-group') || document.querySelector('[id^="shopify-section-footer"]') || document.querySelector('footer') || document.querySelector('.footer');
    }
    function setBarVisibility() {
      const footerElement = getFooterElement();
      const footerInView = footerElement ? footerElement.getBoundingClientRect().top <= window.innerHeight : false;
      const isVisible = !footerInView;
      bar.classList.toggle('is-visible', isVisible);
      bar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }
    function requestVisibilityUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        setBarVisibility();
      });
    }
    function setButtonState(isAvailable) {
      if (!addButton) return;
      currentAvailable = isAvailable;
      addButton.disabled = !isAvailable;
    }
    function findVariantById(variantId) {
      return variants.find(variant => String(variant.id) === String(variantId));
    }
    function getPackProductForm() {
      return packProductForm || mainProduct.querySelector('pack-product-form');
    }
    function getActivePackKey() {
      const packForm = getPackProductForm();
      if (packForm && packForm.activePack) return packForm.activePack;
      const packInput = getSelectedPackInput();
      return packInput ? packInput.value : '';
    }
    function escapePackKey(packKey) {
      if (!packKey) return '';
      return typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(packKey) : packKey;
    }
    function getProductVariantsForPack() {
      const packForm = getPackProductForm();
      if (packForm?.currentProduct?.variants?.length) {
        return packForm.currentProduct.variants;
      }
      return variants;
    }
    function getSelectedPackInput() {
      return mainProduct.querySelector('input[name="pack"]:checked');
    }
    function getSelectedPackOption() {
      const packSelect = mainProduct.querySelector('select[name="pack-select"]');
      return packSelect && packSelect.options.length ? packSelect.options[packSelect.selectedIndex] : null;
    }
    function getPackQuantity() {
      const packInput = getSelectedPackInput();
      const packOption = getSelectedPackOption();
      const rawQuantity = packInput ? packInput.dataset.packQuantity : packOption ? packOption.dataset.packQuantity : '';
      return Math.max(1, parseInt(rawQuantity || '1', 10) || 1);
    }
    function getSelectedPackLabel() {
      const packInput = getSelectedPackInput();
      if (packInput) {
        const packLabel = packInput.closest('label')?.querySelector('.pack-label, .pack-select-dropdown__option-label');
        return formatPackLabel(packLabel ? packLabel.textContent : packInput.value, getPackQuantity());
      }
      const packOption = getSelectedPackOption();
      if (packOption) return formatPackLabel(packOption.textContent || packOption.value, getPackQuantity());
      return '';
    }
    function getSubscriptionWidgetRoot() {
      const planForm = mainProduct.querySelector('selling-plan-form');
      if (planForm) return planForm;
      const packForm = getPackProductForm();
      const packPurchaseOptions = packForm?.querySelector('fieldset.purchase-options');
      if (packPurchaseOptions) return packPurchaseOptions;
      return mainProduct.querySelector('fieldset.purchase-options');
    }
    function isSubscriptionWidgetVisible() {
      const root = getSubscriptionWidgetRoot();
      if (!root || !isVisibleElement(root)) return false;
      const subscriptionLabel = root.querySelector('[data-option="subscription"]');
      if (subscriptionLabel && !isVisibleElement(subscriptionLabel)) return false;
      return root.style.display !== 'none';
    }
    function isSubscriptionSelected() {
      const root = getSubscriptionWidgetRoot();
      if (!root) return false;
      const subscriptionRadio = root.querySelector('[name="purchase_option"][value="subscription"]');
      return !!(subscriptionRadio && subscriptionRadio.checked);
    }
    function getMainSellingPlanSelect() {
      const root = getSubscriptionWidgetRoot();
      return root ? root.querySelector('select[name="selling_plan"]') : null;
    }
    function getSelectedPlanText() {
      if (!isSubscriptionSelected() || !isSubscriptionWidgetVisible()) return '';
      const sellingPlanSelect = getMainSellingPlanSelect();
      if (!sellingPlanSelect || !sellingPlanSelect.options.length) return '';
      const selectedPlan = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
      if (!selectedPlan?.value) return '';
      return cleanText(selectedPlan.label || selectedPlan.textContent);
    }
    function resolveVariantFromSlot(slotEl) {
      const productVariants = getProductVariantsForPack();
      if (!slotEl || !productVariants?.length) return null;
      const selects = slotEl.querySelectorAll('select[data-pack-key][data-flavor-index]');
      const optionValues = Array.from(selects).map(select => select.value);
      if (optionValues.length) {
        const exact = productVariants.find(variant => Array.isArray(variant.options) && variant.options.every((opt, idx) => opt === optionValues[idx]));
        if (exact) return exact;
      }
      const fallbackSelect = slotEl.querySelector('select');
      const variantId = fallbackSelect?.options?.[fallbackSelect.selectedIndex]?.dataset?.variantId;
      if (variantId) {
        return productVariants.find(variant => String(variant.id) === String(variantId)) || {
          id: parseInt(variantId, 10)
        };
      }
      return null;
    }
    function getSellingPlanId() {
      if (!isSubscriptionSelected()) return null;
      const sellingPlanSelect = getMainSellingPlanSelect();
      if (sellingPlanSelect?.value) return parseInt(sellingPlanSelect.value, 10);
      return null;
    }
    function getQuantityPackBaseVariant(productVariants) {
      const root = mainProduct.querySelector('.pack-selector[data-multi-pack="true"]');
      if (!root || root.dataset.packUseQuantityPricing !== 'true') return null;
      const variantId = root.dataset.packPricingVariantId;
      if (!variantId || !productVariants?.length) return null;
      return productVariants.find(variant => String(variant.id) === String(variantId)) || null;
    }
    function usesPackAddToCart() {
      const packForm = getPackProductForm();
      if (packForm && packForm.usesPackUi) return true;
      const activePack = getActivePackKey();
      if (!activePack) return false;
      const flavorSlots = mainProduct.querySelectorAll(`.flavor-selector-${escapePackKey(activePack)}`);
      for (const slot of flavorSlots) {
        if (isVisibleElement(slot)) return true;
      }
      return false;
    }
    function buildPackCartItems() {
      const activePack = getActivePackKey();
      if (!activePack) return [];
      const sellingPlan = getSellingPlanId();
      const packScope = getPackProductForm() || mainProduct;
      const productVariants = getProductVariantsForPack();
      const packKey = escapePackKey(activePack);
      const packSelectors = packScope.querySelectorAll(`.flavor-selector-${packKey}`);
      const visibleSlots = Array.from(packSelectors).filter(selector => isVisibleElement(selector));
      if (visibleSlots.length) {
        const items = [];
        visibleSlots.forEach(slot => {
          const variant = resolveVariantFromSlot(slot);
          if (!variant?.id) return;
          items.push(_objectSpread({
            id: parseInt(variant.id, 10),
            quantity: 1
          }, sellingPlan ? {
            selling_plan: sellingPlan
          } : {}));
        });
        return items;
      }
      const packQuantity = getPackQuantity();
      const qtyUnitVariant = getQuantityPackBaseVariant(productVariants);
      const mainVariantInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
      const variantId = qtyUnitVariant?.id || (mainVariantInput?.value ? parseInt(mainVariantInput.value, 10) : null);
      if (!variantId) return [];
      return [_objectSpread({
        id: parseInt(variantId, 10),
        quantity: packQuantity
      }, sellingPlan ? {
        selling_plan: sellingPlan
      } : {})];
    }
    function showStickyError(message) {
      const errorWrapper = stickyProductForm?.querySelector('.product-form__error-message-wrapper');
      const errorMessage = stickyProductForm?.querySelector('.product-form__error-message');
      if (!errorWrapper || !errorMessage) return;
      errorMessage.textContent = message || '';
      errorWrapper.hidden = !message;
    }
    function setStickyLoading(isLoading) {
      if (!addButton) return;
      const spinner = addButton.querySelector('.loading__spinner');
      if (isLoading) {
        addButton.setAttribute('aria-disabled', 'true');
        addButton.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
      } else {
        addButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        if (!packSubmitError) addButton.removeAttribute('aria-disabled');
      }
    }
    function submitPackItems(evt) {
      syncFromMainForm();
      const items = buildPackCartItems();
      if (!items.length) {
        showStickyError('Please select flavors for all items.');
        return;
      }
      showStickyError('');
      packSubmitError = false;
      setStickyLoading(true);
      const config = typeof fetchConfig !== 'undefined' ? fetchConfig('json') : {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const body = {
        items
      };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(section => section.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }
      config.body = JSON.stringify(body);
      const startMarker = typeof CartPerformance !== 'undefined' ? CartPerformance.createStartingMarker('add:wait-for-subscribers') : null;
      fetch(`${routes.cart_add_url}`, config).then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          throw new Error('Response is not JSON');
        }
        return response.json();
      }).then(response => {
        if (response.status) {
          packSubmitError = true;
          if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'sticky-pack-atc',
              errors: response.errors || response.description,
              message: response.message
            });
          }
          showStickyError(response.description || response.message || 'Unable to add items to cart.');
          return;
        }
        packSubmitError = false;
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
          const cartUpdatePromise = publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sticky-pack-atc',
            cartData: response
          });
          if (startMarker && cartUpdatePromise?.then) {
            cartUpdatePromise.then(() => {
              if (typeof CartPerformance !== 'undefined') {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              }
            });
          }
        }
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        const renderCart = () => cart.renderContents(response);
        if (typeof CartPerformance !== 'undefined') {
          CartPerformance.measure('add:paint-updated-sections', renderCart);
        } else {
          renderCart();
        }
      }).catch(error => {
        console.error('Sticky pack add to cart failed:', error);
        packSubmitError = true;
        showStickyError('Unable to add items to cart. Please try again.');
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'sticky-pack-atc',
            errors: error.message,
            message: 'Unable to add items to cart.'
          });
        }
      }).finally(() => {
        setStickyLoading(false);
        if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof CartPerformance !== 'undefined' && evt) {
          CartPerformance.measureFromEvent('add:user-action', evt);
        }
      });
    }
    function handleStickySubmit(evt) {
      syncFromMainForm();
      if (!usesPackAddToCart()) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      submitPackItems(evt);
    }
    function getSelectedFlavorValues() {
      const values = [];
      mainProduct.querySelectorAll('[class*="flavor-selector-"]').forEach(selector => {
        if (!isVisibleElement(selector)) return;
        const selects = selector.querySelectorAll('select[data-pack-key][data-flavor-index]');
        if (selects.length) {
          const flavorSelect = Array.from(selects).find(select => {
            const name = (select.closest('label')?.textContent || select.name || '').toLowerCase();
            return name.includes('flavor') || selects.length === 1;
          });
          const target = flavorSelect || selects[0];
          if (target?.value) values.push(target.value);
          return;
        }
        const select = selector.querySelector('select');
        if (select?.value) values.push(select.value);
      });
      return values;
    }
    function updateSelectedSummary() {
      if (!selectedOptions || !currentVariant) return;
      const summary = [];
      const seen = {};
      const packLabel = getSelectedPackLabel();
      const flavorValues = getSelectedFlavorValues();
      function addValue(value, allowDuplicate) {
        const label = cleanText(value);
        const key = normalizeSummaryValue(label);
        if (!label || key === 'default title') return;
        if (!allowDuplicate) {
          if (seen[key]) return;
          seen[key] = true;
        }
        summary.push(label);
      }
      addValue(packLabel);
      if (flavorValues.length) {
        flavorValues.forEach(value => addValue(value, true));
      } else {
        (currentVariant.options || []).forEach(value => addValue(value, false));
      }
      if (!summary.length) {
        selectedOptions.hidden = true;
        selectedOptions.textContent = '';
        return;
      }
      selectedOptions.hidden = false;
      selectedOptions.textContent = summary.join(' / ');
    }
    function getDisplayedSelectedPrice() {
      const subscriptionRoot = getSubscriptionWidgetRoot();
      const priceSelector = isSubscriptionSelected() ? '[data-option="subscription"] [data-pack-price]' : '[data-option="onetime"] [data-pack-price]';
      const selectedPrice = subscriptionRoot ? subscriptionRoot.querySelector(priceSelector) : null;
      if (selectedPrice && cleanText(selectedPrice.textContent)) return cleanText(selectedPrice.textContent);
      if (!currentVariant) return '';
      return formatMoney((currentVariant.priceCents || 0) * getPackQuantity(), currentVariant.price);
    }
    function updateButtonPrice() {
      if (!buttonPrice) return;
      buttonPrice.textContent = getDisplayedSelectedPrice();
    }
    function updateSelectedFrequency() {
      if (!selectedFrequency || !selectedFrequencyText) return;
      const planText = getSelectedPlanText();
      if (planText) {
        selectedFrequency.removeAttribute('hidden');
        selectedFrequencyText.textContent = planText;
      } else {
        selectedFrequency.setAttribute('hidden', '');
        selectedFrequencyText.textContent = '';
      }
    }
    function syncPurchaseState() {
      const subscriptionSelected = isSubscriptionSelected();
      const sellingPlanSelect = getMainSellingPlanSelect();
      const selectedPlan = sellingPlanSelect && sellingPlanSelect.options.length ? sellingPlanSelect.options[sellingPlanSelect.selectedIndex] : null;
      const planValue = selectedPlan ? selectedPlan.value : '';
      if (sellingPlanInput) {
        sellingPlanInput.disabled = !subscriptionSelected || !planValue;
        sellingPlanInput.value = subscriptionSelected ? planValue : '';
      }
      if (quantityInput) quantityInput.value = getPackQuantity();
      updateSelectedSummary();
      updateSelectedFrequency();
      updateButtonPrice();
      setButtonState(currentAvailable);
    }
    function updateSelectedVariant(variantId) {
      const variant = findVariantById(variantId);
      if (!variant || !variantInput) return;
      variantInput.value = variant.id;
      currentVariant = variant;
      updateSelectedSummary();
      updateButtonPrice();
      setButtonState(variant.available);
    }
    function syncFromMainForm() {
      const mainVariantInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
      if (mainVariantInput && mainVariantInput.value) updateSelectedVariant(mainVariantInput.value);
      syncPurchaseState();
    }
    mainProduct.addEventListener('change', event => {
      if (bar.contains(event.target)) return;
      window.requestAnimationFrame(syncFromMainForm);
    });
    if (form) {
      form.addEventListener('submit', handleStickySubmit, true);
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, event => {
        const data = event && event.data ? event.data : {};
        if (data.sectionId !== sectionId || !data.variant) return;
        updateSelectedVariant(data.variant.id);
        window.requestAnimationFrame(syncPurchaseState);
      });
    }
    if (window.MutationObserver) {
      const subscriptionRoot = getSubscriptionWidgetRoot();
      if (subscriptionRoot) {
        new MutationObserver(syncFromMainForm).observe(subscriptionRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'hidden']
        });
      }
    }
    syncFromMainForm();
    window.setTimeout(syncFromMainForm, 500);
    setBarVisibility();
    window.addEventListener('scroll', requestVisibilityUpdate, {
      passive: true
    });
    window.addEventListener('resize', requestVisibilityUpdate);
  }
  function initAllStickyAtc() {
    document.querySelectorAll('[data-main-product-sticky-atc]').forEach(initStickyAtc);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStickyAtc);
  } else {
    initAllStickyAtc();
  }
  document.addEventListener('shopify:section:load', initAllStickyAtc);
})();
/******/ })()
;